import { useEffect, useState } from "react"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { supabase } from "@/lib/data"

interface Props {
  value?: string
  onChange: (value: string) => void
  placeholder?: string
}

export function ModelSelect({ value = "", onChange, placeholder = "Select a model" }: Props) {
  const [models, setModels] = useState<{ title: string, value: string }[]>([])

  useEffect(() => {
    supabase.from("models").select("title, model, provider").order("title").then(({ data }) => {
      setModels((data ?? []).filter(m => m.provider && m.model).map(m => ({ title: m.title || m.model!, value: `${m.provider}/${m.model}` })))
    })
  }, [])

  return <Select value={value} onValueChange={onChange}>
    <SelectTrigger>
      <SelectValue placeholder={placeholder} />
    </SelectTrigger>
    <SelectContent>
      {value && !models.some(m => m.value === value) && <SelectItem value={value}>{value}</SelectItem>}
      {models.map(m => <SelectItem key={m.value} value={m.value}>{m.title}</SelectItem>)}
    </SelectContent>
  </Select>
}
